import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { fill: "none" }, [
      _createElementVNode("rect", {
        width: "64",
        height: "64",
        rx: "4"
      }),
      _createElementVNode("path", {
        stroke: "#000",
        "stroke-width": "8",
        d: "M24 12v40m16-40v40"
      })
    ], -1)
  ]))]))
}
export default { render: render }